export const getById = <T extends { id: string | number }>(items: T[], id: string | number, name = "item"): T => {
    const foundItem = items.find((item) => item.id === id);

    if (!foundItem) {
        throw new Error(`${name} is missing.`);
    }

    return foundItem;
};
